import GiftcardIncompatibleProductsModal from '../../components/modals/giftcard-incompatible-products.modal';
import GiftcardIncompatibleProductsModalAll from '../../components/modals/giftcard-incompatible-products-all.modal';
import GiftcardInsufficientModal from '../../components/modals/giftcard-insufficient.modal';
import { ModalIsLeavingPayment } from '../fallback/billing-leaving-payment';
import { ModalPaymentError } from '../fallback/billing-payment-fallback';
import { ModalRemoveGiftCard } from '../payment-methods';

export const BillingModals = () => {
  return (
    <>
      <ModalRemoveGiftCard />
      <GiftcardInsufficientModal />
      <GiftcardIncompatibleProductsModal />
      <GiftcardIncompatibleProductsModalAll />
      <ModalPaymentError />
      <ModalIsLeavingPayment />
      <div id="modal-summary-expanded"></div>
      <div id="modal-giftcard-remove"></div>
      <div id="modal-giftcard-fallback"></div>
      <div id="modal-discount-coupon-remove"></div>
      <div id="modal-payment-fallback"></div>
      <div id="modal-leaving-payment"></div>
      <div id="modal-club-paris-info"></div>
      <div id="modal-club-paris-remove"></div>
      <div id="modal-need-invoice"></div>
      <div id="modal-delete-company"></div>
      <div id="modal-invoice-and-gift-card"></div>
      <div id="modal-invoice-and-gift-card-and-club-paris"></div>
      <div id="modal-invoice-and-gift-card-as-product"></div>
      <div id="modal-cencopay-qr"></div>
      <div id="modal-cencopay-qr-change-method"></div>
      <div id="modal-cencopay-get-the-app"></div>
      <div id="modal-giftcar-insufficient"></div>
    </>
  );
};
